import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-inner">
        <p className="cookie-text">
          Diese Webseite nutzt ausschließlich technisch notwendige Speicherung (LocalStorage) 
          für Ihren Quiz-Fortschritt und Ihre Sprachauswahl. Es werden keine Tracking-Cookies 
          oder Analyse-Tools verwendet. Mehr dazu in unserer{' '}
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>
        <button className="cookie-btn" onClick={accept} data-testid="cookie-accept-btn">
          Verstanden
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
